// FLAGS: health-data
// The two React Query clients every query in the app runs on, and therefore the in-memory store for
// check-in answers, chat messages and session notes.
import { QueryClient } from "react-query";
import { consultStaleTime } from "@src/queries/staletimes";

export const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      useErrorBoundary: true,
      suspense: true,
      staleTime: consultStaleTime,
    },
  },
});

// FLAGS: health-data
// Logout clears only the client above — `queryClient.clear()` in services/auth.service.ts — never this
// one, and 21 route elements in routes.tsx mount on it, including the whole Vitality check-in flow. A
// second login in the same tab inside React Query's 5-minute cacheTime therefore finds the previous
// user's cached answers, results and consults still present and, at the 20-minute default staleTime,
// still fresh, so they render before any refetch.
export const queryClientWithoutSuspense = new QueryClient({
  defaultOptions: {
    queries: {
      useErrorBoundary: true,
      staleTime: consultStaleTime,
    },
  },
});
